import React from 'react'
import Form from '../common/form/Form'
import closeIcon from '../../../img/icons/X.svg'
import { Link } from 'react-router-dom'


export default function WasCreatedModal() {
    return (
        <div className='auth__form__ecp__box'>
            <Link to='/login'>
                <div className='icon__block'>
                    <img src={closeIcon} />
                </div>
            </Link>
            <div>
                <div className='auth__form__ecp was_created'>
                    <h3>Учетная запись уже <span className='was_created'>создана</span></h3>
                    <Form validate={true}>
                        <p>
                            Завершите регистрацию по ссылке из письма, отправленного на электронную почту, указанную при регистрации.
                        </p>
                        <p>
                            Если вы не нашли письмо, проверьте папку "Спам" либо запросите повторную отправку по номеру 8&nbsp;800&nbsp;2000&nbsp;180 или у вашего менеджера
                        </p>
                    </Form>
                    <div className='form__buttons_ecp blocked'>
                        <Link to='/login'>
                            <button className='reg_by_ds_repeat_btn'>Назад</button>
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    )
}
